import { createSystemEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IVehicleType } from "../../utils/types/models";

export default createSystemEntityReducer<IVehicleType>(Endpoint.VehicleTypes);
